CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
CustomFieldOption = require 'app/scripts/models/custom-field-option'

class CustomFieldOptionList extends CollectionWithHelpers
  model: CustomFieldOption
  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (option) -> option.get('pos')

module.exports = CustomFieldOptionList
